import * as React from 'react';

export enum SYNC_DOCUMENTS_WITH_DB_ACTIONS {
  ENABLE = 'enable',
  DISABLE = 'disable',
}

type Action = { type: SYNC_DOCUMENTS_WITH_DB_ACTIONS.ENABLE } | { type: SYNC_DOCUMENTS_WITH_DB_ACTIONS.DISABLE };

type Dispatch = (action: Action) => void;

export type SyncDocumentsWithDBStatus = {
  SyncDocumentsWithDBEnabled: boolean | undefined;
};

type SyncDocumentsWithDBStatusProviderProps = { children: React.ReactNode };

type SyncDocumentsWithDBStatusContextType = {
  state: SyncDocumentsWithDBStatus;
  dispatch: Dispatch;
};

export const SyncDocumentsWithDBStatusContext = React.createContext<SyncDocumentsWithDBStatusContextType | undefined>(
  undefined
);

function syncDocumentsWithDBReducer(_: SyncDocumentsWithDBStatus, action: Action) {
  switch (action.type) {
    case SYNC_DOCUMENTS_WITH_DB_ACTIONS.ENABLE: {
      return { SyncDocumentsWithDBEnabled: true };
    }
    case SYNC_DOCUMENTS_WITH_DB_ACTIONS.DISABLE: {
      return { SyncDocumentsWithDBEnabled: false };
    }
    default: {
      throw new Error(`Unhandled action type`);
    }
  }
}

function SyncDocumentsWithDBStatusProvider({ children }: SyncDocumentsWithDBStatusProviderProps) {
  const [state, dispatch] = React.useReducer(syncDocumentsWithDBReducer, { SyncDocumentsWithDBEnabled: true });

  const memoDispatch = React.useMemo(() => dispatch, [])
  const value = { state, dispatch: memoDispatch };
  return (
    <SyncDocumentsWithDBStatusContext.Provider value={value}>{children}</SyncDocumentsWithDBStatusContext.Provider>
  );
}

function useSyncDocumentsWithDBStatus() {
  const context = React.useContext(SyncDocumentsWithDBStatusContext);
  if (context === undefined) {
    throw new Error('useSyncDocumentsWithDBStatus must be used within a SyncDocumentsWithDBStatusProvider');
  }
  return context;
}

export { SyncDocumentsWithDBStatusProvider, useSyncDocumentsWithDBStatus };
